import React, { lazy  , useEffect} from 'react';
import { Route, Routes , useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './App.css';
import { I18nextProvider } from 'react-i18next'; 
import i18n from './i18n';
import GuardedConnectedUserRoute from './GuardedRoutes/GuardedConnectedUserRoute';
import GuardedAdminRoute from './GuardedRoutes/GuardedAdminRoute';
import DashboardAdmin from './Pages/Dashboard_Admin/DashboardAdmin';
// import LogRocket from 'logrocket';
// import setupLogRocketReact from 'logrocket-react';
import { getLocalStorageItemWithExpiration } from './data/helper';
import { setCredentials , setToken } from './Redux/auth/authSlice';
import ConnectedUserRoute from './GuardedRoutes/ConnectedUserRoute';
import ProtectCreateProjectRoute from './GuardedRoutes/ProtectCreateProjectRoute';
// import Loader from './Components/Loader';
import Layout from './Components/Layouts/Layout';
import DashbordLayout from "./Components/Layouts/DashbordLayout";
import SubscribePlan from './Pages/common/Subscription/SubscribePlan';
import NotFound from './Pages/NotFound';
// import { useLocation } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import AutoLogout from './Components/AutoLogout ';
import ResendVerificationLink from './Pages/Authentification/Complete_SignUp/ResendVerificationLink';
import RouteTracker from './Components/common/RouteTracker';
import ErrorBoundary from './Components/errors/ErrorBoundary';
import { initGA  , trackPageView } from './utils/analytics';
import { initGTM } from './utils/gtm';

// Utiliser React.lazy pour le code splitting
const SignIn = lazy(() => import('./Pages/Authentification/SignIn'));
const SignUp = lazy(() => import('./Pages/Authentification/SignUp'));
const Failure = lazy(() => import('./Pages/Authentification/Failure'));
const Success = lazy(() => import('./Pages/Authentification/Success'));
const SuccessSignUp = lazy(() => import('./Pages/Authentification/SuccessSignUp'))
const Subscription = lazy(() => import('./Pages/common/Subscription/Subscription'));
// const GuardedUserMemberRoutes = lazy(() => import('./GuardedRoutes/GuardedUserMemberRoutes'));
const UserProfile = lazy(() => import('./Pages/common/UserProfile'));
const VerificationCode = lazy(() => import('./Pages/Authentification/Complete_SignUp/VerificationCode'));
const ResetPasswordEmail = lazy(() => import('./Pages/Authentification/ResetPasswordEmail'));
const ResetPassword = lazy(() => import('./Pages/Authentification/ResetPassword'));
const PasswordResetSucces = lazy(() => import('./Pages/Authentification/PasswordResetSucces'));
const ForgotPassword = lazy(() => import('./Pages/Authentification/ForgotPassword'));
const ChooseRole = lazy(() => import('./Pages/Authentification/Complete_SignUp/ChooseRole'));
const SocialSignUp = lazy(() => import('./Pages/Authentification/SocialSignUp'));
const Projects = lazy(() => import('./Pages/Member/Project/Projects'));
const CreateProject = lazy(() => import('./Pages/Member/Project/CreateProject'));
const ProjectDetails = lazy(() => import('./Pages/Member/Project/ProjectDetails'));
const CompanyLegal = lazy(() => import('./Pages/common/Company/CompanyLegal'));
const MyCompany = lazy(() => import('./Pages/common/Company/MyCompany'));
const Employees = lazy(() => import('./Pages/common/Company/Employees'));
const NewEmployee = lazy(() => import('./Pages/common/Company/NewEmployee'));
const Dashboard = lazy(() => import('./Pages/Member/Dashboard'));
const DashboardInvestor = lazy(() => import('./Pages/Investor/DashboardInvestor'));
const DashboardPartner = lazy(() => import('./Pages/Partner/DashboardPartner'));
const Investors = lazy(() => import('./Pages/Member/Investor/Investors'));
const InvestorDetails = lazy(() => import('./Pages/Member/Investor/InvestorDetails'));
const InvestorRequestHistory = lazy(() => import('./Pages/Member/Investor/InvestorRequestHistory'));
const MyInvestors = lazy(() => import('./Pages/Member/Investor/MyInvestor'));
const Documents = lazy(() => import('./Pages/common/Documents'));
const Events = lazy(() => import('./Pages/common/Event/Events'));
const History = lazy(() => import('./Pages/common/History'));
const Users = lazy(() => import('./Pages/Dashboard_Admin/Users'));
const UpcomingEvents = lazy(() => import('./Pages/common/Event/UpcomingEvent'));
const UpcomingEventDetails = lazy(() => import('./Pages/common/Event/UpcomingEventDetails'));
const PastEvents = lazy(() => import('./Pages/common/Event/PastEvents'));
const ChoosePlan = lazy(() => import('./Pages/common/Subscription/ChoosePlan'));
const Notifications = lazy(() => import('./Pages/common/Notifications'));
const VerificationEmail = lazy(() => import('./Pages/Authentification/Complete_SignUp/VerificationEmail'));
const RedirectFromSignIn = lazy(() => import('./Pages/Authentification/RedirectFromSignIn'));
const ResendVerification = lazy(() => import('./Pages/Authentification/Complete_SignUp/ResendVerificationLink'));
const VerifyFailure = lazy(() => import('./Pages/Authentification/VerifyFailure'));
const ManageSubscriptionCredits = lazy(() => import('./Pages/common/Subscription/ManageSubscriptionCredits'));
const Investment = lazy(()  => import('./Pages/Investor/Investment/Investment'))
const MyInvestment = lazy(() => import('./Pages/Investor/MyInvestment/MyInvestment'))
const MyInvestmentDetails = lazy(() => import('./Pages/Investor/MyInvestment/MyInvestmentDetails'))
const InvestmentRequestHistory = lazy(() => import('./Pages/Investor/Investment/InvestmentRequestHistory'))
const UpcomingSponsorEvent = lazy(() => import('./Pages/Partner/Sponsoring/UpcomingSponsorEvent'))
const SponsorEventDetails = lazy(() => import('./Pages/Partner/Sponsoring/SponsorEventDetails'))
const SponsorCurrentRequests = lazy(() => import('./Pages/Partner/Sponsoring/SponsorCurrentRequests'))
const PastSponsorEvent = lazy(() => import('./Pages/Partner/Sponsoring/PastSponsorEvent'))
const SponsorCurrentRequestDetails = lazy(() => import('./Pages/Partner/Sponsoring/SponsorCurrentRequestDetails'))
const PastSponsorEventDetails = lazy(() => import('./Pages/Partner/Sponsoring/PastSponsorEventDetails'))
const SponsorRequestHistory = lazy(() => import('./Pages/Partner/Sponsoring/SponsorRequestHistory'))
const SponsorRequestHistoryDetails = lazy(() => import('./Pages/Partner/Sponsoring/SponsorRequestHistoryDetails'))
const CompanyProfile = lazy(() => import('./Pages/Investor/Company/CompanyProfile'))
const MembersHistory = lazy(() => import('./Pages/Dashboard_Admin/Histories/MembersHistory'))
const InvestorsHistory = lazy(() => import('./Pages/Dashboard_Admin/Histories/InvestorsHistory'))
const CompaniesHistory = lazy(() => import('./Pages/Dashboard_Admin/Histories/CompaniesHistory'))

function App() {

  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const lang = queryParams.get('lang');
      if (lang) {
          i18n.changeLanguage(lang);
          localStorage.setItem('language', lang); 
      }
  }, []);

  useEffect(() => {
    const rememberMe = getLocalStorageItemWithExpiration('rememberMe');

    if (rememberMe) {
      const userToken = getLocalStorageItemWithExpiration('userToken');
      const userData = getLocalStorageItemWithExpiration('userData');

      if (userToken && userData) {
        // Mettre à jour sessionStorage
        sessionStorage.setItem('userToken', userToken);
        sessionStorage.setItem('userData', userData);
        dispatch(setCredentials(JSON.parse(userData)));
        dispatch(setToken(userToken));
      }
    } else {
      const userToken = sessionStorage.getItem('userToken');
      const userData = sessionStorage.getItem('userData');

      if (userToken && userData) {
        dispatch(setCredentials(JSON.parse(userData)));
        dispatch(setToken(userToken));
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      // Vérifier si les cookies ne sont pas déjà définis
      if (!document.cookie.includes('user=')) {
        // Set cookie with user data
        document.cookie = `user=${JSON.stringify(userData)}; path=/; secure; SameSite=None`;
      }
    }
  }, []);

  useEffect(() => {
      initGA();
      initGTM();
    }
  , []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location]);

  return (
    <I18nextProvider i18n={i18n}> {/* Add I18nextProvider */}
 
      <AutoLogout>
        <div className='font-dm-sans-regular overflow-hidden'>
          <RouteTracker>
            <ScrollToTop>
            <div className='min-h-screen'>
              <ErrorBoundary>
                <Routes>
                  <Route element={<DashbordLayout />}>
                    <Route element={<GuardedConnectedUserRoute />}>
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/dashboard/investor" element={<DashboardInvestor />} />
                      <Route path="/dashboard/partner" element={<DashboardPartner />} />
                      <Route path="/manage-subscription-credits" element={<ManageSubscriptionCredits />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/investors" element={<Investors />} />
                      <Route path="/my-investors" element={<MyInvestors />} />
                      <Route path="/investors/:investorId" element={<InvestorDetails />} />
                      <Route path="/my-investors/:investorId" element={<InvestorDetails />} />
                      <Route path="/investor-requests-history" element={<InvestorRequestHistory />} />
                      <Route path="/projects" element={<Projects />} />
                      <Route element={<ProtectCreateProjectRoute />}>
                        <Route path="/projects/create" element={<CreateProject />} />
                      </Route>
                      <Route path="/projects/edit/:projectId" element={<CreateProject />} />
                      <Route path="/projects/details/:projectId" element={<ProjectDetails />} />
                      <Route path="/company/legal" element={<CompanyLegal />} />
                      <Route path="/my-company" element={<MyCompany />} />
                      <Route path="/investor-profile" element={<CompanyProfile />} />
                      <Route path="/company/employees" element={<Employees />} />
                      <Route path="/company/employees/create" element={<NewEmployee />} />
                      <Route path="/company/employees/edit/:employeeId" element={<NewEmployee />} />
                      <Route path="/documents" element={<Documents />} />
                      <Route path="/events/participate" element={<Events />} />
                      <Route path="/events/upcoming" element={<UpcomingEvents />} />
                      <Route path="/events/past" element={<PastEvents />} />
                      <Route path="/events/upcoming/:id" element={<UpcomingEventDetails />} />
                      <Route path="/events/participate/:id" element={<UpcomingEventDetails />} />
                      <Route path="/events/past/:id" element={<UpcomingEventDetails />} />
                      <Route path="/user-profile" element={<UserProfile />} />
                      <Route path="/subscription" element={<Subscription />} />
                      <Route path="/subscription/choose-plan" element={<ChoosePlan />} />

                      <Route path="/history" element={<History />} />
                      <Route path="/history/members" element={<MembersHistory />} />
                      <Route path="/history/investors" element={<InvestorsHistory />} />
                      <Route path="/history/companies" element={<CompaniesHistory />} />
                      <Route path="/notifications" element={<Notifications />} />
                      <Route path="/subscription/subscribe-plan" element={<SubscribePlan />} />
                      <Route path="/investments" element={<Investment />} />
                      <Route path="/my-investments" element={<MyInvestment />} />
                      <Route path="/investments/:id" element={<MyInvestmentDetails />} />
                      <Route path="/my-investments/:id" element={<MyInvestmentDetails />} />
                      <Route path="/investment-requests-history/:id" element={<MyInvestmentDetails />} />
                      <Route path="/investment-requests-history" element={<InvestmentRequestHistory />} />
                      <Route path="/sponsor-events/upcoming" element={<UpcomingSponsorEvent />} />
                      <Route path="/sponsor-events/:id" element={<SponsorEventDetails />} />
                      <Route path="/sponsor-current-requests" element={<SponsorCurrentRequests />} />
                      <Route path="/sponsor-events/past" element={<PastSponsorEvent />} />
                      <Route path="/sponsor-current-requests/:id" element={<SponsorCurrentRequestDetails />} />
                      <Route path="/sponsor-events/past/:id" element={<PastSponsorEventDetails />} />
                      <Route path="/sponsor-request-history" element={<SponsorRequestHistory />} />
                      <Route path="/sponsor-request-history/:id" element={<SponsorRequestHistoryDetails />} />

                    </Route>
                    <Route element={<GuardedAdminRoute />}>
                      <Route path="/dashboard/admin" element={<DashboardAdmin />} />
                    </Route>
                  </Route>
                  <Route element={<Layout />}>
                    <Route element={<GuardedConnectedUserRoute />}>
                      <Route path="/choose-role" element={<ChooseRole />} />
                      <Route path="/post-sign-in" element={<RedirectFromSignIn />} />
                    </Route>
                    <Route element={<ConnectedUserRoute />}>
                      <Route   path="/sign-in" element={<SignIn />} />
                      <Route   path="/" element={<SignIn />} />
                      <Route   path="/sign-up" element={<SignUp />} />
                      <Route   path="/social-sign-up" element={<SocialSignUp />} />
                    </Route>
                    <Route path="/verify-code" element={<VerificationCode />} />
                    <Route path="/verify-email" element={<VerificationEmail />} />
                    <Route path="/reset-password-link" element={<ResetPasswordEmail />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/password-reset-success" element={<PasswordResetSucces />} />
                    <Route path="/resend-verification-link" element={<ResendVerificationLink />} />

                    <Route path="/failure" element={<Failure/>}/>
                    <Route path="/success" element={<Success/>}/>
                    <Route path="/sign-up-success" element={<SuccessSignUp/>}/>
                    <Route path="/resend-verification" element={<ResendVerification />} />
                    <Route path="/verify-failure" element={<VerifyFailure />} />
                  </Route>
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ErrorBoundary>
            </div>
            </ScrollToTop>
          </RouteTracker>
        </div>
      </AutoLogout>
  </I18nextProvider>

 
  );
}

export default App;
